import $ from "jquery";
import { ISO_8601 } from "moment";

export const initDateTimeComponentEditor = (editor) => {
  // Initialize the date time picker
  var format;
  if (editor.dataset.dateOnly === "True") {
    format = "L";
  } else {
    format = "L LT";
  }
  $(editor).datetimepicker({
    format: format,
    extraFormats: [ISO_8601],
  });

  // Set the hidden input value
  var target = $(editor).closest(".post-component").find("input.target");
  var val = target.val();
  if (val) {
    var m = new Date(val);

    editor.dataset.date = m;
    editor.dataset.defaultDate, m;
    editor.dataset.useCurrent = false;
    if (editor.dataset.dateOnly === "True") {
      editor.value = m.toLocaleDateString();
    } else {
      editor.value = m.toLocaleString();
    }
  }

  // Responsd to changes
  $(editor).on("dp.change", function (e) {
    var target = $(this).closest(".post-component").find("input.target");
    //
    // note the .toISOString() converts the date to a UTC time
    // thereby discarding the local timezone information. We should
    // really preserve that information and store all datetimes in
    // the DB with the local timezone they were entered in.
    //
    target.val(e.date ? e.date.toISOString() : "");
  });
};
